<template>
  <div class="TextInput"
    :class="textInputClasses">

    <input class="TextInput-input"
      ref="input"
      @input="update($event.target.value)"
      @keyup="handleKeyup"
      @focus="handleFocus"
      @blur="handleBlur"
      :id="id"
      :name="name"
      :type="type"
      :value="value"
      :placeholder="placeholder" />

    <div class="TextInput-submit"
      @click="submit">

      <icon class="TextInput-submitIcon"
        :width="large ? '20px' : '16px'"
        :height="large ? '20px' : '16px'"
        name="plus" />

    </div>

  </div>
</template>

<script>
import isiOS from 'is-ios'

export default {
  props: {
    id: {
      type: String
    },
    name: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: String
    },
    placeholder: {
      type: String
    },
    large: {
      type: Boolean,
      default: false
    },
    focus: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isFocused: false
    }
  },

  computed: {
    textInputClasses () {
      return {
        'TextInput--isLarge': this.large,
        'TextInput--isFocused': this.isFocused,
        'TextInput--is-iOS': isiOS
      }
    }
  },

  mounted () {
    if (!this.focus) return
    setTimeout(() => {
      this.$refs.input.focus()
    }, 250)
  },

  methods: {
    update (value) {
      this.$emit('input', value)
    },

    handleKeyup (event) {
      if (event.key === 'Enter') {
        this.submit()
        return
      }

      this.$emit('keyup', { event, value: this.$refs.input.value })
    },

    handleFocus () {
      this.isFocused = true
      this.$emit('focus')
    },

    handleBlur () {
      // TODO: do not enable this
      // - Causes value to be lost on blur event
      // - Remove isFocused stuff, after verifying we don't need it
      // this.isFocused = false
    },

    submit () {
      this.$emit('submit', this.$refs.input.value)
    }
  }
}
</script>

<style>
@import 'properties';

.TextInput {
  display: inline-flex;
  width: 264px;
  height: 30px;
  -webkit-font-smoothing: antialiased;
}

.TextInput--isLarge {
  height: 42px;
}

.TextInput-input {
  border: none;
  flex-grow: 1;
  padding: 3px var(--unit-05) 0;
  background-color: var(--c-grey-xxlt);
  color: var(--c-grey-lt);
  font-family: var(--font-family-sans);
  font-size: 11px;
  line-height: 18px;
  font-weight: 400;
  font-style: italic;
  -webkit-appearance: none;
  border-radius: 0;
}

.theme-dk .TextInput-input {
  background-color: var(--c-black);
  color: var(--c-grey-lt);
}

.TextInput--isLarge .TextInput-input {
  font-size: 13px;
}

.TextInput--is-iOS .TextInput-input {
  font-size: 16px;
}

.TextInput-input::placeholder {
  color: var(--c-grey-lt);
}

.TextInput-input:focus {
  outline: none;
}

.TextInput-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  background-color: var(--c-grey-xxlt);
  cursor: pointer;
}

.theme-dk .TextInput-submit {
  background-color: var(--c-black);
}

.TextInput-submitIcon {

}

.TextInput-submitIcon svg {
  fill: var(--c-grey-lt) !important;
}

.TextInput-submitIcon:hover svg {
  fill: var(--c-blue) !important;
}
</style>



// WEBPACK FOOTER //
// TextInput.vue?82fe05ae